import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);

const KST = "Asia/Seoul";

export const getDateFromDayNumber = (currentDate: string, day: number) => {
  const dayStr = day.toString().padStart(2, "0");
  const current = dayjs.tz(currentDate, KST).format("YYYY-MM-DD");
  const resultDate = `${current.split("-")[0]}-${
    current.split("-")[1]
  }-${dayStr}`;
  return dayjs.tz(resultDate, KST).format("YYYY-MM-DD");
};

export const formatLabelDate = (dateString: string) => {
  const date = dayjs.tz(dateString, KST).format("YYYY-MM-DD");
  const [year, month] = date.split("-");
  return `${year}년 ${month}월`;
};

export const isDaySelected = (
  currentMonthLabel: string,
  day: number,
  date: string
): boolean => {
  const newDate = getDateFromDayNumber(currentMonthLabel, day);
  return newDate === date;
};

// KST 기준으로 YYYY-MM-DD로 변환
export const fornatDateBydayjs = (isoDate: string): string => {
  return dayjs(isoDate).tz(KST).format("YYYY-MM-DD");
};
